<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'创建订单'}]"/>
        <div class="h-piece">
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>订单信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="q" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="销售区域" class="h-elformWrap-2">
                                <el-input v-model="xsqyStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="销售组织编码" class="h-elformWrap-2">
                                <el-input v-model="xszzStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="分销渠道" class="h-elformWrap-2">
                                <el-input v-model="fxqdStr" readonly></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->


            <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>客户信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="orderdata" ref="form1" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">

                            <el-form-item prop="soldToName" label="售达方名称"
                                          :rules="[
								  { required: true, message: '请输入售达方名称', trigger: 'input'},
								]" class="h-elformWrap-2">
                                <el-input v-model="orderdata.soldToName" placeholder="请输入" readonly>
                                    <i
                                            class="el-icon-search el-input__icon"
                                            slot="suffix"
                                            @click="openShoudf">
                                    </i>
                                </el-input>
                            </el-form-item>

                            <el-form-item prop="soldToAreaName" label="售达方区域" :rules="[
								  { required: true, message: '请输入售达方区域', trigger: 'change'},
								]"  class="h-elformWrap-2">
                                <el-input v-model="orderdata.soldToAreaName" readonly placeholder="自带出"></el-input>
                            </el-form-item>

                            <el-form-item prop="customerChannelCode" label="客户渠道" :rules="[
								  { required: true, message: '请输入客户渠道', trigger: 'change'},
								]"   class="h-elformWrap-2">
                                <brselect clearable category="sales_region" :v="orderdata.customerChannelCode"
                                          v-model="orderdata.customerChannelCode"></brselect>
                            </el-form-item>

                            <el-form-item prop="isStockUp" label="是否备货" :rules="[
								  { required: true, message: '请输入是否备货', trigger: 'change'},
								]"   class="h-elformWrap-2"  >
                                <brselect clearable category="shifou_keyong" :v="orderdata.isStockUp"
                                          v-model="orderdata.isStockUp"></brselect>
                            </el-form-item>

                            <el-form-item prop="contactName" label="收货联系人" :rules="[
								  { required: true, message: '请输入收货联系人', trigger: 'change'},
								]"   class="h-elformWrap-2">
                                <el-input v-model="orderdata.contactName" placeholder="请输入"></el-input>
                            </el-form-item>

                            <el-form-item
                                    label="预计收货日期"
                                    class="h-elformWrap-2"
                                    width="120px"
                                    :rules="[
								  { required: true, message: '请输入预计收货日期', trigger: 'change'},
								]"
                                    prop="receivedTime">
                                <div class="block">
                                    <el-date-picker
                                            v-model="orderdata.receivedTime"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="--选择--"
                                            :picker-options="pickerOptions">
                                    </el-date-picker>
                                </div>
                            </el-form-item>

                            <el-form-item label="联系电话" width="300"  :rules="[
								  { required: true, message: '请输入联系电话', trigger: 'change'},
								]" class="h-elformWrap-2" prop="firsttelephone" style="float: left">
                                <div class="block">
                                    <el-input v-model="orderdata.firsttelephone" placeholder="请输入"
                                    ></el-input>
                                </div>
                            </el-form-item>

                            <el-form-item label="选择收货地址" :rules="[
								  { required: true, message: '请输入选择收货地址', trigger: 'blur'},
								]"  prop="toAddress" class="h-elformWrap-2">
                                <el-input clearable v-model="orderdata.toAddress" readonly >
                                    <i
                                            class="el-icon-search el-input__icon"
                                            slot="suffix"
                                            @click="selectAreadialog">
                                    </i>
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>

            <!--------------------------------售后信息--------------->
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>售后信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="order" ref="form2" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item prop="tuihyy" label="退货原因" :rules="[
								  { required: true, message: '请输入退货原因', trigger: 'change'},
								]"  class="h-elformWrap-2">
                                <brselect clearable category="tuihuo_yuanyin" :v="order.tuihyy"
                                          v-model="order.tuihyy"></brselect>
                            </el-form-item>

                            <el-form-item prop="tuihyydes" label="质量检测描述" :rules="[
								  { required: true, message: '请输入质量检测描述', trigger: 'blur'},
								]"  class="h-elformWrap-2">
                                <el-input v-model="order.tuihyydes" placeholder="质量检测描述"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>

        </div>
        <!-------------------------------------------------------客户信息-------------------------------------------------------------------->


        <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
        <div class="h-table h-mrt30    bbbb"  >
            <div class="h-pieceTitle2 message">
                <h1 class="h1">发货产品信息</h1>
            </div>
            <el-table
                    ref="multipleTable"
                    :data="tableData1"
                    stripe
					border
                    style="width: 100%">
                <el-table-column
                        fixed
                        type="index"
                        label="#"
                        width="40">
                </el-table-column>

                <el-table-column
                        prop="materialCode"
                        label="产品编码"
						:show-overflow-tooltip="true"
                        width="190">
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        label="产品描述"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="proModelName"
                        label="产品型号"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="订单数量"
                        width="110"
                        :rules="[
								  { required: true, message: '请输入排序名称'},
								  { type: 'number', message: '必须为数字值',trigger: 'change'}
								]">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.proNumber" @change="getTotalPrice(scope.row)"
                                  placeholder="请输入"
                                  class="DshuR" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="currencyCode"
                        label="币种"
                        width="140">
                </el-table-column>
                <el-table-column
                        prop="proBenchmarkPrice"
                        label="基准价"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="finalPrice"
                        label="最终成交价"
                        width="110">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.finalPrice"
                                  placeholder="请输入"
                                  class="DshuR" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="totalPrice"
                        label="总价"
                        width="120">
                    <template slot-scope="scope">
                        {{ (scope.row.totalPrice = new big(scope.row.proNumber || 0).times((scope.row.finalPrice || scope.row.proBenchmarkPrice || 0)).toString())}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                       <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                v-model="scope.row.id"
                                @click="deleteThis1(scope.row.id)">
                            删除
                        </el-button>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis1(scope.row.id)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
            <div style="background-color: rgb(94, 182, 233);"  @click="showProcuct1">
                <img src="../../assets/images/pimg/jiahao.png" alt="">
            </div>
        </div>
        <!-------------------------------------------------------产品信息-------------------------------------------------------------------->


        <div class="jieguo">
            <span class="bizhong">币种</span>
            <span class="renminbi">{{ currency }}</span>
            <span class="dingdan">订单总价</span>
            <span class="yuan">{{ allTotalPrice }}</span>
            <span class="xianjin">现金余额</span>
            <span class="money">{{ cashBalance }}</span>
            <span class="xianjin">现金占用</span>
            <span class="money">{{ cashOccupy }}</span>
            <span class="xianjin">信贷余额</span>
            <span class="zhangqi">{{ creditBalance }}</span>
            <span class="xianjin">信贷占用</span>
            <span class="zhangqi">{{ creditOccupy }}</span>
            <span class="jiazhi">净价值</span>
            <span class="make">￥5000</span>
        </div>



        <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
        <div class="h-table h-mrt30    bbbb"  >
            <div class="h-pieceTitle2 message">
                <h1 class="h1">退货产品信息</h1>
            </div>
            <el-table
                    ref="multipleTable"
                    :data="tableData2"
                    stripe
					border
                    style="width: 100%">
                <el-table-column
                        fixed
                        type="index"
                        label="#"
                        width="40">
                </el-table-column>

                <el-table-column
                        prop="materialCode"
                        label="产品编码"
						:show-overflow-tooltip="true"
                        width="190">
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        label="产品描述"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="proModelName"
                        label="产品型号"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="订单数量"
                        width="110"
                        :rules="[
								  { required: true, message: '请输入排序名称'},
								  { type: 'number', message: '必须为数字值',trigger: 'change'}
								]">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.proNumber" @change="getTotalPrice(scope.row)"
                                  placeholder="请输入"
                                  class="DshuR" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="currencyCode"
                        label="币种"
                        width="140">
                </el-table-column>
                <el-table-column
                        prop="proBenchmarkPrice"
                        label="基准价"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="finalPrice"
                        label="最终成交价"
                        width="110">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.finalPrice"
                                  placeholder="请输入"
                                  class="DshuR" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="totalPrice"
                        label="总价"
                        width="120">
                    <template slot-scope="scope">
                        {{ (scope.row.totalPrice = new big(scope.row.proNumber || 0).times((scope.row.finalPrice || scope.row.proBenchmarkPrice || 0)).toString())}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                       <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                v-model="scope.row.id"
                                @click="deleteThis2(scope.row.id)">
                            删除
                        </el-button>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis2(scope.row.id)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
            <div style="background-color: rgb(94, 182, 233);"   @click="showProcuct2">
                <img src="../../assets/images/pimg/jiahao.png" alt="">
            </div>
        </div>
        <!-------------------------------------------------------产品信息-------------------------------------------------------------------->


        <div class="jieguo">
            <span class="bizhong">币种</span>
            <span class="renminbi">{{ currency }}</span>
            <span class="dingdan">订单总价</span>
            <span class="yuan">{{ allTotalPrice }}</span>
            <span class="xianjin">现金余额</span>
            <span class="money">{{ cashBalance }}</span>
            <span class="xianjin">现金占用</span>
            <span class="money">{{ cashOccupy }}</span>
            <span class="xianjin">信贷余额</span>
            <span class="zhangqi">{{ creditBalance }}</span>
            <span class="xianjin">信贷占用</span>
            <span class="zhangqi">{{ creditOccupy }}</span>
            <span class="jiazhi">净价值</span>
            <span class="make">￥5000</span>
        </div>
        <div class="anniu">
            <el-row>
                <a href="/dingd/myOrderList">
                    <el-button class="h-btn h-bBtn h-bgwhite" style="margin-right:10px;">返回</el-button>
                </a>
                <el-button class="h-btn h-bBtn h-bggreen" @click="createNewOrder(10)">暂存</el-button>
                <el-button class="h-btn h-bBtn h-bgblue2" @click="createNewOrder(20)">确认提交</el-button>
            </el-row>
        </div>
        <!--------------------------------------------------------------------收货地址弹出框-------------------------------------------------------->

        <!--物料-->
        <wxwl :visible.sync="showwuliaodialog1" v-if="showwuliaodialog1" :ddlx="ddlx" @choseObj="choseWuliao1" :usercode="shoudfusercode"
              title="选择物料"/>
        <!--物料-->
        <wxwl :visible.sync="showwuliaodialog2" v-if="showwuliaodialog2" :ddlx="ddlx" @choseObj="choseWuliao2" :usercode="shoudfusercode"
              title="选择物料"/>
        <!--售达方-->
        <shoudf :visible.sync="showshdfdialog" v-if="showshdfdialog" @choseObj="choseshoudf" oneflag :usercode="currentUser"
              title="选择售达方"/>
        <!--地址信息-->
        <areaSelect :visible.sync="showdizhiflag" v-if="showdizhiflag" @choseObj="choseDizhi" title="选择地址"/>


    </div>
</template>


<script>
    import ss from '../../api/SystemService'
    import wxwl from '../../components/dialog/wxwl'
    import shoudf from '../../components/dialog/selectshdf'

    export default {
        components: {
            wxwl,
            shoudf
        },
        data() {
            return {
                //销售渠道，销售组织，分销渠道
                xsqyStr:'',
                xszzStr:'',
                fxqdStr:'',

                //地址，
                showdizhiflag: false,
                //售达方
                showshdfdialog:false,
                //物料
                showwuliaodialog1: false,
                showwuliaodialog2: false,

                //订单类型，
                ddlx:null,
                currentUser: null,
                shoudfusercode: null,

                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },

                cflag: false,
                //现金及信贷
                cashBalance: 0,
                cashOccupy: 0,
                creditBalance: 0,
                creditOccupy: 0,
                allTotalPrice: 0,
                currency: '',
                expectTime: '',
                q:{},

                //新建订单对话框数据

                //创建订单数据
                order: {
                    orderId:null, // 主键

                    orderCategory:null, // 订单类型
                    orderCategory1:null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,

                    orderSaleCompany:null, // 销售公司

                    remark:null, // 是否已提交sap,1-是,0-否

                    orderStatus:null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过,
                    addressCode:null, // 省市区联动表返回值里的主键
                    tuihyy:null, // 退货原因
                    tuihyydes:null, // 退货原因说明
                },
                orderdata:{
                    id:null, // 主键
                    oId:null, // 订单编号，关联bsc_order的主键id
                    disChannelCode:null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
                    proGroupCode:null, // 产品组编码
                    saleDepartmentCode:null, // 销售部门编码
                    saleGroupCode:null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织
                    orderCategory:null, // 订单类型:1-内销,2-外销
                    isStockUp:null, // 是否备货      1：是；0：否
                    customerChannelCode:null, // 客户渠道
                    receivedTime:null, // 预计收货时间
                    soldToCode:null, // 售达方编码
                    soldToName:null, // 售达方名称
                    soldToAreaCode:null, // 售达方地区编码
                    soldToAreaName:null, // 售达方地区编码,false
                    shipToCode:null, // 送达方编码
                    remark:null, // 回款状态
                    shipToName:null, // 送达方名称
                    shipToAreaCode:null, // 送达方地区编码
                    invoiceCode:null, // 开票方编码
                    payerCode:null, // 付款方编码
                    orderPrice:null, // 订单总价
                    orderNetWorth:null, // 订单净价值
                    currencyCode:null, // 币种编码
                    zCode:null, // Z1选项
                    poId:null, // PO号
                    contactName:null, // 联系人名称
                    dcCode:null, // 配送中心编码
                    toProvincesCode:null, // 送达省份编码
                    toCityCode:null, // 送达城市编码
                    note:null, // 订单备注
                    regionCode:null, // 区域编码
                    postcode:null, // 邮政编码
                    firsttelephone:null, // 第一个电话
                    secondtelephone:null, // 第二电话
                    extraPrice:null, // 定制加价
                    customized:null, // 定制需求
                    specialPrice:null, // 特价价格
                    orderType:null, // 订单分类
                    availableNum:null, // 可用库存
                    payMethod:null, // 付款方式
                    spare1:null, //
                    spare2:null, //
                    spare4:null, //
                    spare3:null, //
                    toAddress:null, // 收货地址
                    toCompanyname:null, // 送达方公司全称
                    eCode:null, // 12位区域码
                    areaId:null, // 区域详情表关联id
                    posnr:null, // 外销:销售和分销凭证的项目号
                    inco1:null, // 外销:国际贸易条款 (部分1)
                    inco2:null, // 外销:国际贸易条款 (部分2)
                },
                tableData1: [],
                tableData2: [],
            };
        },
        //页面加载前事件
        created() {
            this.q = _.assign(this.q,this.$route.query);
            // 销售区域
            this.xsqyStr=this.$store.getters.dictname("xiaoshou_quyu",this.q.orderCategory);
            //内销
            if(this.q.orderCategory == '1'){
                this.xsqyStr = this.xsqyStr+"/"+this.$store.getters.dictname("xiaoshou_quyu_nx",this.q.orderCategory1);
            //    外销
            }else if(this.q.orderCategory == '2'){
                this.xsqyStr = this.xsqyStr+"/"+this.$store.getters.dictname("xiaoshou_quyu_wx",this.q.orderCategory1);
            }
            this.ddlx = this.q.orderCategory+","+this.q.orderCategory1||''
            //销售组织
            this.xszzStr = this.$store.getters.dictname("YLSalesOrganization_agent",this.q.saleGroupCode);

            // 分销渠道
            this.fxqdStr = this.$store.getters.dictname("fenxiao_qudao",this.q.disChannelCode);
            if(this.q.disChannelCode == 'Z1'){
                this.fxqdStr = this.fxqdStr + this.$store.getters.dictname("fenxiao_qudao_shanghai",this.q.zCode);
            }

            this.order.id = this.q.id||this.$util.getUuid();
            //初始化一部分字段
            this.order.orderCategory=this.q.orderCategory;
            this.order.orderCategory1=this.q.orderCategory1||'';
            //销售组织
            this.orderdata.saleGroupCode=this.q.saleGroupCode;
            //分销渠道
            this.orderdata.disChannelCode=this.q.disChannelCode;
            this.orderdata.zCode=this.q.zCode||'';

            this.currentUser = this._user.usercode

        },

        methods: {

            choseDizhi(obj) {
                console.log("choseDizhi",obj)
                this.order.addressCode = obj.id;
                this.orderdata.areaId = obj.id;
                this.orderdata.toAddress = obj.quobj.namepath;
                if(obj.zhenobj){
                    this.orderdata.toAddress = obj.zhenobj.namepath;
                }
                this.orderdata.toAddress = this.orderdata.toAddress + obj.addrdetail

                this.orderdata.toProvincesCode = obj.shengobj.name;
                this.orderdata.toCityCode = obj.shiobj.name;

                this.showdizhiflag = false;
            },

            //选择售达方
            openShoudf(){
                this.showshdfdialog = true;
            },
            choseshoudf(obj){
                console.log(123,obj)
                this.orderdata.soldToName = obj.username;
                this.orderdata.soldToCode = obj.usercode;
                this.orderdata.soldToAreaCode = obj.area;
                this.orderdata.soldToAreaName = obj.areaname;
                this.orderdata.firsttelephone = obj.phone;
                this.showshdfdialog = false

                //售达方用户
                this.shoudfusercode = this.orderdata.soldToCode
            },
            //选择售达方

            //选择地址
            selectAreadialog() {
                this.showdizhiflag = true;
            },

            //选择物料
            showProcuct1() {
                if(!this.orderdata.soldToCode){
                    this.$msg.msge("请先选择售达方信息！")
                    return;
                }
                this.showwuliaodialog1 = true;
            },
            //选择物料
            showProcuct2() {
                if(!this.orderdata.soldToCode){
                    this.$msg.msge("请先选择售达方信息！")
                    return;
                }
                this.showwuliaodialog2 = true;
            },

            //选择物料
            choseWuliao1(obj) {
                console.log("选中的物料",obj)

                const wl = this.getObjList(obj[0]);

                if(_.find(this.tableData1,{materialCode:wl.materialCode})){
                    this.$msg.msge("该物料号已存在");
                    return;
                }

                this.tableData1.push(wl);
                const wl2 = _.clone(wl);
                wl2.id=this.$util.getUuid();
                this.tableData2.push(wl2);
                this.showwuliaodialog1 = false;
            },
            //选择物料
            choseWuliao2(obj) {
                console.log("选中的物料",obj)
                const wl = this.getObjList(obj[0]);
                this.tableData2.push(wl);
                this.showwuliaodialog2 = false;
            },




            getObjList(obj){
                var wl = {};
                wl.id=this.$util.getUuid();
                wl.materialCode=obj.matecode;//物料编码
                wl.materialName=obj.matedes;//物料名称
                wl.proModelCode=obj.cpdlcode;//产品型号编码
                wl.proModelName=obj.cpdlname;//产品型号名称
                wl.dwcode=obj.dwcode;//单位
                wl.dwname=obj.dwname;//单位
                wl.proNumber=0;//产品数量
                wl.proBenchmarkPrice=obj.jizhj;//产品基准价
                wl.currencyCode=obj.currency;//币种编码
                wl.finalPrice=obj.jizhj;//成交价
                wl.totalPrice=0;//产品总价
                return wl;
            },

            //删除该行项目产品信息
            deleteThis1(x) {
                this.tableData1 = _.reject(this.tableData1, {'id': x});
            },
            deleteThis2(x) {
                this.tableData2 = _.reject(this.tableData2, {'id': x});
            },



            //创建新订单
            createNewOrder(p) {
                this.$refs['form1'].validate((valid1) => {
                    if (valid1) {
                        this.$refs['form2'].validate((valid2) => {
                            if(valid2){
                                if(p=='10'){
                                    this.order.submitflag="暂存"
                                }else if(p=='20'){
                                    this.order.submitflag="提交"
                                }
                                this.order.orderStatus = p;
                                this.order.orderData = this.orderdata;
                                this.order.orderProductList = [...this.tableData1,...this.tableData2];
                                ss.OrderService.createNewOrder(this.order).then(rd => {
                                    this.$msg.msgs(rd.msg);
                                    this.jump();
                                });
                            }else{
                                this.$msg.msge("请完善基本信息后提交");
                            }
                        })
                    }else{
                        this.$msg.msge("请完善基本信息后提交");
                    }
                });

            },
            //跳转页面
            jump() {
                this.$router.push({path: "/dingd/myOrderList"})
            },

        },

    }

</script>

<style scoped>
    .queren {
        background-color: #006aca;
        color: white;
    }

    .anniu {
        margin-left: 6rem;
        margin-top: 30px;
    }

    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .quxiao, .zancun {

        width: 100px;
    }

    .make {
        width: 77px;
        padding-left: 17px;
    }

    .zhangqi {
        width: 80px;
        padding-left: 10px;
    }

    .yuan, .zhanyong, .xianjin, .money, .dingdan, .bizhong, .jiazhi, .renminbi {
        width: 82px;
        padding-left: 20px;
    }

    /* .renminbi {
        width: 80px;
        padding-left: 20px;
    } */

    .renminbi,
    .money,
    .yuan,
    .zhangqi,
    .make {
        background-color: white;
        font-size: 10px;
    }

    .bizhong,
    .dingdan,
    .xianjin,
    .zhanyong,
    .jiazhi {
        background-color: #ebf5ff;
        font-size: 15px;
        padding-left: 20px;
    }

    .bizhong,
    .renminbi,
    .dingdan,
    .money,
    .xianjin,
    .yuan,
    .zhangqi,
    .zhanyong,
    .jiazhi,
    .make {
        font-size: 15px;
        color: black;
        padding: 20px 0;
        padding-left: 10px;
    }

    .jieguo {
        border-bottom: 1px solid rgb(238, 236, 236);
        display: flex;
        margin-top: 12px;
    }

    span {
        color: white;
        position: relative;
        top: -12px;
        left: 20px;
        font-size: 14px;
    }

    img {
        width: 25px;
        padding: 5px 0;
        margin-left: 8rem;
    }

    .newProject {
        margin: 0 20px;
        background-color: rgb(94, 182, 233);
    }

    /* .h-crumbOut {
        margin-bottom: 20px;
    } */

    .h-piece {
        margin: 20px;
    }

    .h1 {
        margin-left: 27px;
    }

    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }

    .bbbb {
        /* padding-top: 5px; */
        margin: 20px 20px 0 20px;
    }

    .message {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }

    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .el-cascader {
        line-height: normal;
    }
</style>
<style>
    .h-pagination {
        text-align: right;
         padding-top: 0rem!important;
         padding-bottom: 0rem!important;
    }
    .n-two .h-formbLine .el-form-item__content .el-select,
    .n-two .el-form .h-formbLine .el-form-item__content .el-select {
        width: 0;
    }

    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }


    /* .el-table__header .el-table-column--selection .cell .el-checkbox::after {
        content: "全选";
        color: white;
        background-color: rgb(93, 172, 236);
        font-size: 10px;
    } */
</style>

<style scoped lang="scss">
    .areaSelect {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        top: 0;
        left: 0;
        z-index: 2019;

        .centerBlock {
            width: 700px;
            height: 400px;
            padding: 20px;
            border-radius: 20px;
            background-color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
</style>
<style>
    .aaa .el-dialog__headerbtn {
        display: none;
    }
</style>
